var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleSso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4 20.342c0-1.064-.096-2.087-.273-3.069H20v5.803h8.073c-.348 1.875-1.405 3.463-2.994 4.527v3.764h4.848c2.837-2.612 4.473-6.457 4.473-11.025z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35c4.05 0 7.445-1.344 9.927-3.634l-4.847-3.764c-1.344.9-3.062 1.432-5.08 1.432-3.907 0-7.214-2.639-8.393-6.184H6.595v3.886C9.064 31.638 14.136 35 20 35z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.607 22.85c-.3-.9-.47-1.861-.47-2.85 0-.989.17-1.95.47-2.85v-3.886H6.595A14.994 14.994 0 005 20c0 2.42.58 4.711 1.595 6.736l5.012-3.886z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.966c2.202 0 4.18.757 5.734 2.243l4.302-4.302C27.44 6.487 24.043 5 20 5 14.136 5 9.064 8.361 6.595 13.264l5.012 3.886c1.18-3.545 4.486-6.184 8.393-6.184z",
    fill: "#EA4335"
  })));
}

export default "data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M34.4 20.342c0-1.064-.096-2.087-.273-3.069H20v5.803h8.073c-.348 1.875-1.405 3.463-2.994 4.527v3.764h4.848c2.837-2.612 4.473-6.457 4.473-11.025z' fill='%234285F4'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 35c4.05 0 7.445-1.344 9.927-3.634l-4.847-3.764c-1.344.9-3.062 1.432-5.08 1.432-3.907 0-7.214-2.639-8.393-6.184H6.595v3.886C9.064 31.638 14.136 35 20 35z' fill='%2334A853'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.607 22.85c-.3-.9-.47-1.861-.47-2.85 0-.989.17-1.95.47-2.85v-3.886H6.595A14.994 14.994 0 005 20c0 2.42.58 4.711 1.595 6.736l5.012-3.886z' fill='%23FBBC05'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 10.966c2.202 0 4.18.757 5.734 2.243l4.302-4.302C27.44 6.487 24.043 5 20 5 14.136 5 9.064 8.361 6.595 13.264l5.012 3.886c1.18-3.545 4.486-6.184 8.393-6.184z' fill='%23EA4335'/%3E%3C/svg%3E";
export { SvgGoogleSso as ReactComponent };